import axios from "axios";
import UrlHelper from "../utilities/UrlHelper";

class OrganizationService {
    getOrganizationByPartialNameOrSite (searchTerm) {
        const queryByPartialNameOrSiteUri = "organizations/search?text=";
        var encodedSearchTerm = encodeURIComponent(searchTerm);

        return axios.get(UrlHelper.getIdentifiApiUrl() + queryByPartialNameOrSiteUri + encodedSearchTerm);
    }

    loadSsoSettingsForSiteId (siteId) {
        return axios.get(UrlHelper.getIdentifiApiUrl() + "organizations/settings/sso/bySite/" + siteId);
    }

    loadSettingsById (id, callback) {
        return axios.get(UrlHelper.getIdentifiApiUrl() + "organizations/settings/" + id);
    }

    loadSsoSettingsById (id) {
        return axios.get(UrlHelper.getIdentifiApiUrl() + "organizations/settings/sso?OrgId=" + id);
    }

    getOrganizationById (id) {
        return axios.get(UrlHelper.getIdentifiApiUrl() + "organizations/id/" + id);
    }

    loadSettingsByTicket (ticket) {
        return axios.post(UrlHelper.getIdentifiApiUrl() + "auth/ticket/validate/", { Ticket: ticket });
    }

    saveSettings (settings) {
        return axios.post(UrlHelper.getIdentifiApiUrl() + "organizations/settings/", settings);
    }

    getLogo (organizationId) {
        return axios.get(UrlHelper.getIdentifiApiUrl() + "organizations/settings/logo/" + organizationId);
    }

    saveLogo ({ organizationId, fileType, fileName, fileAltName, file }) {

        const formData = new FormData();
        formData.set('file', file, fileName);

        return axios.post(UrlHelper.getIdentifiApiUrl() + "organizations/settings/logo/upload/" + organizationId, formData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data'
            },
            params: {
                ContentType: fileType,
                FileName: fileName,
                AltName: fileAltName
            }
        });
    }

    deleteLogo (organizationId) {
        return axios.post(UrlHelper.getIdentifiApiUrl() + "organizations/settings/logo/delete/" + organizationId);
    }
}

export default new OrganizationService();
